module.exports = __webpack_public_path__ + "img/raditubelogoNoAnimation.63697bea.svg";